import { render, staticRenderFns } from "./OrTahoSensor.vue?vue&type=template&id=e9c8613e&scoped=true&"
import script from "./OrTahoSensor.vue?vue&type=script&lang=ts&"
export * from "./OrTahoSensor.vue?vue&type=script&lang=ts&"
import style0 from "./OrTahoSensor.vue?vue&type=style&index=0&id=e9c8613e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c8613e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
